import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from '../PageLayout/CheckBox';
export default function () {
    function onChecked1() {
        this.setState({ download: !this.state.download });
    }
    function onChecked2() {
        this.setState({ email: !this.state.email });
    }
    function onChecked3() {
        this.setState({ useDateRange: !this.state.useDateRange });
    }
    function onChange4(e) {
        this.setState({ dateRangeFrom: e.target.value });
    }
    function onChange5(e) {
        this.setState({ dateRangeTo: e.target.value });
    }
    function onChecked6() {
        this.setState({ excludeDuplicates: !this.state.excludeDuplicates });
    }
    function onClick7() {
        document.getElementById('import-exclusion-list').click();
    }
    function onChange8(e) {
        this.setState({ selectedFileName: e.target.files[0].name });
    }
    function onClick9() {
        this.setState({ importView: false });
    }
    function onClick10() {
        this.setState({
            importView: true,
            showUploadNotice: false,
            selectedFileName: ''
        });
    }
    function onChange11(e) {
        this.setState({ emailAddress: e.target.value });
    }
    function onChange12(e) {
        this.setState({ emailMessage: e.target.value });
    }
    function onClick13() {
        this.props.export(this.state);
    }
    return React.createElement('div', { 'className': 'ui-popup ui-popup--x-small' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Export Options')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'fabricators-popup-content job-board-export-content' }, React.createElement('div', { 'className': 'job-board-export-options' }, React.createElement('div', { 'className': 'job-board-export-option' }, React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.download,
        'text': 'Download',
        'onChecked': onChecked1.bind(this),
        'innerStyle': 'grey'
    })), React.createElement('div', { 'className': 'job-board-export-option' }, React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.email,
        'text': 'Email',
        'onChecked': onChecked2.bind(this),
        'innerStyle': 'grey'
    }))), React.createElement('div', { 'className': 'job-board-export-body' }, React.createElement('div', { 'className': 'job-board-date-range' }, React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.useDateRange,
        'text': 'Use Date Range',
        'onChecked': onChecked3.bind(this),
        'innerStyle': 'grey'
    }), this.state.useDateRange ? React.createElement('div', { 'key': '1148' }, React.createElement('h5', {}, 'Set Date Range to Export'), React.createElement('div', { 'className': 'job-board-export-half' }, React.createElement('div', { 'className': 'job-board-export-half-left' }, React.createElement('label', { 'className': 'generic-popup-textbox-label' }, 'From'), React.createElement('input', {
        'type': 'date',
        'className': 'generic-popup-textbox',
        'value': this.state.dateRangeFrom,
        'onChange': onChange4.bind(this)
    })), React.createElement('div', { 'className': 'job-board-export-half-right' }, React.createElement('label', { 'className': 'generic-popup-textbox-label' }, 'To'), React.createElement('input', {
        'type': 'date',
        'className': 'generic-popup-textbox',
        'value': this.state.dateRangeTo,
        'onChange': onChange5.bind(this)
    })))) : null), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.excludeDuplicates,
        'text': 'Exclude Duplicates',
        'onChecked': onChecked6.bind(this),
        'innerStyle': 'grey'
    }), React.createElement('div', { 'className': 'job-board-import-export' }, React.createElement('h5', {}, 'Exclusion List'), this.state.importView ? React.createElement('div', { 'key': '2337' }, React.createElement('div', { 'className': 'job-board-import-export-chooseFile' }, React.createElement('button', {
        'className': 'ui-button ui-button--gray',
        'onClick': onClick7.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Choose File')), React.createElement('span', {}, this.state.selectedFileName), this.state.showUploadNotice ? React.createElement('div', { 'key': '2786' }, '\r\n                        Exclusion List has been successfully updated.\r\n                    ') : null), React.createElement('input', {
        'style': { display: 'none' },
        'id': 'import-exclusion-list',
        'type': 'file',
        'accept': '.csv',
        'onChange': onChange8.bind(this)
    }), React.createElement('div', { 'className': 'job-board-import-export-buttons' }, React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': onClick9.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.uploadExclusionList
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Upload')))) : null, this.state.importView !== true ? React.createElement('div', {
        'className': 'job-board-import-export-buttons',
        'key': '3703'
    }, React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': onClick10.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Import')), React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.props.downloadExclusionList
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Download Exclusion List'))) : null), this.state.email ? [
        React.createElement('label', {
            'className': 'generic-popup-textbox-label',
            'key': '43351'
        }, 'Email'),
        React.createElement('input', {
            'type': 'email',
            'className': 'generic-popup-textbox',
            'value': this.state.emailAddress,
            'onChange': onChange11.bind(this),
            'key': '43353'
        }),
        React.createElement('label', {
            'className': 'generic-popup-textbox-label',
            'key': '43355'
        }, 'Message'),
        React.createElement('textarea', {
            'className': 'generic-popup-textarea-small',
            'value': this.state.emailMessage,
            'onChange': onChange12.bind(this),
            'key': '43357'
        })
    ] : null))), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.props.closeJobBoardExport
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': onClick13.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Export'))));
}